
























  import {Component, Emit, Prop, Vue} from "vue-property-decorator";

@Component
export default class VideoPlayerPoster extends Vue {
  @Prop({ default: '' }) src: string;
  @Prop({ default: true }) isShown: boolean;
  @Prop() loading: boolean;

  get posterImageStyle (): any {
    return {
      backgroundImage: `url(${this.src})`
    }
  }

  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }

  @Emit('click-play')
  onClickPlay (): void {}
}
